import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../../store/configureStore';
import ElasticSearchResultsContainer from '../../containers/investor/ElasticSearchResultsContainer';


const elasticSearchResults = props => (
  <Provider store={configureStore(props)}>
    <ElasticSearchResultsContainer />
  </Provider>
);

export default elasticSearchResults;
